import { render, staticRenderFns } from "./sender-email-domains-tab.vue?vue&type=template&id=6228c8e7"
import script from "./sender-email-domains-tab.vue?vue&type=script&lang=js"
export * from "./sender-email-domains-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports